/**
 * AVA-602 GAP-15 (N37): the API refuses a Tag save that reaches a relationship link whose automatic
 * sync is still being set up, as 409 SYNC_BASELINE_PENDING (AutomaticSyncBaselinePendingException).
 * Tag editors show a generic "Error while saving", so the HTTP layer shows the reason once.
 */
export const SYNC_BASELINE_PENDING_CODE = 'SYNC_BASELINE_PENDING';

const FALLBACK_MESSAGE =
  'Sync is still being set up for a register record linked to this Tag. Try saving again in a minute.';

/** The user-facing message for a SYNC_BASELINE_PENDING response, or '' for any other error. */
export function syncBaselinePendingMessage(error) {
  if (error?.response?.status !== 409) return '';
  const data = error.response.data || {};
  const code = data.Message ?? data.message;
  if (code !== SYNC_BASELINE_PENDING_CODE) return '';
  const detail = data.Detail ?? data.detail;
  return typeof detail === 'string' && detail.trim() ? detail.trim() : FALLBACK_MESSAGE;
}
